import { Params } from '@/libs/types';
import { axios } from '@/libs/api.request';
// import { getCanvasFingerprint } from '@/libs/tools';
import { Response } from '@/types/request.d';
import { localRead } from '@/libs/util';

// 登录
export const login = ({
    loginName, userName, email, password, status, language, uniqueId, shop_id, shop_name, source, redirect_url, tem_token, auth_code, code,
}: Params) => {
    const data: any = {
        // login_name: loginName,
        remember: status,
        language,
        tem_token,
        // online_status,
    };
    if (password) {
        data.password = password;
    }
    if (loginName) {
        data.login_name = loginName;
    }
    if (userName) {
        data.user_name = userName;
    }
    if (email) {
        data.email = email;
    }
    // const mac = getCanvasFingerprint();
    // if (mac) {
    //     data.c_id = mac;
    // }
    if (uniqueId) {
        data.unique_id = uniqueId;
    }

    if (shop_id && source) {
        data.shop_id = shop_id;
        data.shop_name = shop_name;
        data.source = source;
    }

    if (auth_code && source) {
        data.auth_code = auth_code;
        data.source = source;
    }

    if (code && source) {
        data.code = code;
        data.source = source;
    }

    if (redirect_url) {
        data.redirect_url = redirect_url;
    }

    data.domain = window.location.hostname;

    const local = localRead('local');
    if (local && local !== 'zh-CN') {
        data.language = local;
    }
    return axios.request({
        url: 'sys/user/passport/login',
        data,
        method: 'post',
    });
};

export interface getWechatCodeParams {
    scene: string;
    language: string;
    source?: string;
    timezone: string;
    sys_user_id?: string;
    invite_code?: string;
    shop_id?: string;
}

export interface getWechatCodeResponse {
    qrcode_url: string;
    ticket: string;
}

// 获取微信二维码
export const getWechatCode = (data: getWechatCodeParams) => {
    return axios.request<Response<getWechatCodeResponse>>({
        url: '/sys/user/passport/weixin-qrcode',
        data,
        method: 'post',
    });
};

// 退出登录
export const logout = () => axios.request({
    url: 'sys/user/passport/logout',
    method: 'post',
});

// 注册
export const register = ({
    name,
    user_name,
    projectName,
    email,
    phone,
    password,
    code,
    inviteCode,
    language,
    source,
    timeZone,
    uniqueId,
    shop_name,
    shop_id,
    shop_source,
    type,
    redirect_url,
    verify_ticket,
    verify_randstr,
    verify_code,
}: Params) => {
    const data: any = {};
    if (name) {
        data.name = name;
    }
    if (user_name) {
        data.user_name = user_name;
    }
    if (verify_ticket) {
        data.verify_ticket = verify_ticket;
    }
    if (verify_randstr) {
        data.verify_randstr = verify_randstr;
    }
    if (email) {
        data.email = email;
    }
    if (phone) {
        data.phone = phone;
    }
    if (password) {
        data.password = password;
    }
    if (code) {
        data.code = code;
    }
    if (inviteCode) {
        data.invite_code = inviteCode;
    }
    if (language) {
        data.language = language;
    }
    if (source) {
        data.source = source;
    }
    if (timeZone) {
        data.time_zone = timeZone;
    }
    if (projectName) {
        data.project_name = projectName;
    }

    // const mac = getCanvasFingerprint();
    // if (mac) {
    //     data.c_id = mac;
    // }
    if (uniqueId) {
        data.unique_id = uniqueId;
    }

    if (shop_name) {
        data.shop_name = shop_name;
    }

    if (shop_id) {
        data.shop_id = shop_id;
    }

    if (shop_source) {
        data.shop_source = shop_source;
    }

    if (redirect_url) {
        data.redirect_url = redirect_url;
    }

    if (type) {
        data.type = type;
    }

    if (verify_code) {
        data.verify_code = verify_code;
    }

    return axios.request({
        url: '/sys/user/passport/quick-login',
        data,
        method: 'post',
    });
};
// 发送修改密码注册验证码
export const sendCode = ({ email, language, type = 'reset_password' }: Params) => axios.request({
    url: '/sys/user/passport/send-validate-code',
    data: {
        email,
        language,
        type,
    },
    method: 'post',
});

// 发送邮箱注册验证码
export const sendRegEmail = ({
    email, key, language, shop_id, type, shop_source,
}: Params) => {
    const params: any = {
        email,
        key,
        language,
    };

    if (shop_id) {
        params.shop_id = shop_id;
    }

    if (type) {
        params.type = type;
    }

    if (shop_source) {
        params.shop_source = shop_source;
    }

    return axios.request({
        url: 'sys/user/passport/send-active-email',
        params,
        method: 'get',
    });
};

// 发送手机注册验证码
export const sendRegMessage = (phone: number) => {
    const data = {
        phone,
    };
    return axios.request({
        url: 'sys/user/passport/send-reg-phone',
        data,
        method: 'post',
    });
};

// 忘记密码发送短信
export const sendResetPasswordPhone = (phone: number) => axios.request({
    url: 'sys/user/passport/send-reset-password-phone',
    method: 'post',
    data: {
        phone,
    },
});

// 忘记密码验证短信的验证码
export const verifyPasswordCode = ({ phone, code }: Params) => axios.request({
    url: 'sys/user/passport/verify-password-code',
    method: 'post',
    data: {
        phone,
        code,
    },
});

// 忘记密码发送重置密码邮件
export const sendResetPasswordEmail = ({
    email,
    url,
}: Params) => axios.request({
    url: 'sys/user/passport/send-reset-password-email',
    method: 'post',
    data: {
        email,
        url,
    },
});

interface UpdateResetPasswordData{
    email?: string;
    phone?: string;
    code: string;
    password: string;
}

// 重置密码最后一步提交新密码
export const updateResetPassword = (data: UpdateResetPasswordData) => axios.request({
    url: '/sys/user/passport/reset-password',
    method: 'post',
    data,
});

// 接受企业邀请
export const updateResetGroup = ({
    token,
    type,
}: Params) => axios.request({
    url: 'sys/user/passport/update-reset-group',
    method: 'post',
    data: {
        token,
        type,
    },
});

interface ThirdAccountLoginParams {
    shop_id: string;
    source: string;
    encryption: string;
}
interface ThirdAccountLoginRes {
    cpl: string;
    plugin_name?: string;
}
// 独立站账号登录接口
export const thirdAccountLogin = (data: ThirdAccountLoginParams) => axios.request<Response<ThirdAccountLoginRes>>({
    url: '/sys/user/passport/third-account-login',
    method: 'post',
    data,
    customTips: true,
});

// 注册
export const shopQuickRegister = (data: {
    user_name?: string;
    password?: string;
    source: string;
    shop_id: string;
    verify_ticket?: string;
    verify_randstr?: string;
    unique_id: string;
    time_zone: string;
    language: string;
}) => {
    return axios.request({
        url: '/sys/user/passport/shop-quick-register',
        data,
        method: 'post',
        customTips: true,
    });
};

interface LoginRes {
    cpl: string;
    plugin_id: string;
    plugin_bind_status: string;
    redirect_url: string;
    verify_key: string;
}

export interface LoginParamsType {
    data: string;
    domain: string;
}

/**
 * tg登录、注册
 * @param data
 * @returns
 */
export const telegramLogin = (data: LoginParamsType) => axios.request<Response<LoginRes>>({
    url: '/sys/user/passport/telegram-login',
    method: 'post',
    data,
});

/**
 * fb登录、注册
 * @param data
 * @returns
 */
export const facebookLogin = (data: LoginParamsType) => axios.request<Response<LoginRes>>({
    url: '/sys/user/passport/facebook-login',
    method: 'post',
    data,
});

export interface RecordSourceData {
    source: string;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_term?: string;
    bd_vid?: string;
    campaign_id?: string;
    group_id?: string;
    ad_id?: string;
    gcl_id?: string;
    source_data?: string;
}

/**
 * 记录来源
 * @param data
 * @returns
 */
export const recordSource = (data: RecordSourceData) => axios.request({
    url: '/sys/user/passport/record-source',
    method: 'post',
    data,
});

type ThirdPartySSOLoginData = {
    access_token: string;
    domain: string;
}

export type ThirdPartySSOLoginRes = {
    cpl: string;
    redirect_url: string;
    id: string;
    page_model: '0' | '1'; // 页面模式 0-不设置 1-设置隐藏侧边栏等
}

/**
 * 第三方单点登录
 * @param data
 */
export const thirdPartySSOLogin = (data: ThirdPartySSOLoginData) => axios.request<Response<ThirdPartySSOLoginRes>>({
    url: '/sys/user/passport/third-party-login',
    method: 'post',
    data,
});

interface verifyParams {
    // login api 返回的key
    verify_key: string;
    // 用户ID
    id: string;
    // 二次验证码
    code: string;
}

interface verifyRes {
    cpl: string;
    id: string;
}

// 判断是否需要两步验证
export const verifyTwice = (data: verifyParams) => axios.request<Response<verifyRes>>({
    url: 'sys/user/passport/check-two-verify',
    data,
    method: 'post',
});

export interface WhatsappLoginData {
    code?: string;
    domain: string;
    password?: string;
    phone: string;
    scene_type: '1' | '2' | '3'; // 1-登录 2-注册 3-绑定
}

export const whatsappLogin = (data: WhatsappLoginData) => axios.request({
    url: '/sys/user/passport/whatsapp-login',
    method: 'post',
    data,
});

export const whatsappBind = (data: WhatsappLoginData) => axios.request({
    url: 'sys/project/individual-whatsapp/whatsapp-bind-verify',
    method: 'post',
    data,
});

export interface SendWhatsappCode {
    phone: string;
    scene_type: '1' | '2' | '3'; // 1-登录 2-注册 3-绑定
    verify_ticket: string,
    verify_randstr: string,
    customTips?: boolean;
}

export const sendWhatsappCode = (data: SendWhatsappCode) => axios.request({
    url: '/sys/user/passport/send-whatsapp-code',
    method: 'post',
    data,
    customTips: data?.customTips ?? false,
});
